import type { HeroSlide } from '@/types/drama';

export const heroes: HeroSlide[] = [
  { id: 'h1', dramaId: '1001', slogan: '都市霓虹下，寻找属于自己的一束光' },
  { id: 'h2', dramaId: '1002', slogan: '锦绣长歌起，一诺定江山' },
  { id: 'h3', dramaId: '1010', slogan: '职场如战场，唯有实力不被辜负' },
  { id: 'h4', dramaId: '1017', slogan: '江湖路远，唯剑与心不可负' },
  { id: 'h5', dramaId: '1003', slogan: '迷雾之下，真相只有一个' },
];